module.exports = __webpack_public_path__ + "static/media/Not-Search.a1f892b7.svg";